/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-09-24 10:45:44
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-17 17:49:59
 */
import axios from "../../utils/axios";

// 品牌管理
export function getList(query) {
    return axios({
        url: "/HfSenceMgnt4Back/list",
        method: "get",
        params: query
    });
}
//品牌删除
export function deleteBrand(query) {
    return axios({
        url: "/HfSenceMgnt4Back/delete",
        method: "get",
        params: query
    });
}
// 品牌增加
export function addBrand(data) {
    return axios({
        url: "/HfSenceMgnt4Back/insert",
        method: "post",
        data: data
    });
}

// 品牌修改
export function updateBrand(data) {
    return axios({
        url: "/HfSenceMgnt4Back/update",
        method: "post",
        data: data
    });
}
//标签列表

// 品牌修改
export function getUserSearchList(query) {
    return axios({
        url: "mbUserSearch/getList",
        method: "get",
        params: query
    });
}
//添加/修改
export function add(data) {
    return axios({
        url: "mbUserSearch/add",
        method: "post",
        data: data
    });
}
//删除标签
export function deleteSearch(data) {
    return axios({
        url: "mbUserSearch/delete",
        method: "post",
        data: data
    });
}



//应用场景删除
export function deleteApi(query) {
  return axios({
      url: "/HfSenceMgnt4Back/delete",
      method: "get",
      params: query
  });
}

// 所属父级
export function getClassifyRank(query) {
  return axios({
      url: "/HfSenceMgnt4Back/obtainOneHfSence",
      method: "get",
      params: query
  });
}

// 新删除
export function deleteBatchApi(data) {
  return axios({
      url: "/HfSenceMgnt4Back/deleteBatch",
      method: "post",
      data: data
  });
}
